import XLSX from 'xlsx'
// -- 產生 sheet------------------
/*
const csv2sheet = (csv) => {
  const sheet = {}
  csv = csv.split('\n')
  csv.forEach((row, i) => {
    row = row.split(',')
    if (i === 0) sheet['!ref'] = 'A1:' + String.fromCharCode(65 + row.length - 1) + (csv.length - 1)
    row.forEach((col, j) => {
      sheet[String.fromCharCode(65 + j) + (i + 1)] = { v: col }
    })
  })
  return sheet
}
*/
// 資料轉sheet fieldnames=['日期', '單號',..]
const rows2sheet = (names, fieldnames, rows) => {
  const result = []
  rows.forEach(row => {
    const item = []
    fieldnames.forEach((fieldname, index) => {
      item[index] = row[fieldname]
    })
    result.push(item)
  })
  result.unshift(names)
  const sheet = XLSX.utils.aoa_to_sheet(result)
  return sheet
}
// --- sheet轉blob -------
const sheet2blob = (sheet, sheetName) => {
  sheetName = sheetName || 'sheet1'
  const workbook = {
    SheetNames: [sheetName],
    Sheets: {}
  }
  workbook.Sheets[sheetName] = sheet
  const wopts = {
    bookType: 'xlsx', // 文件類型
    bookSST: false, // 是否生成Shared String Table，開啟效能會下降
    type: 'binary'
  }
  const wbout = XLSX.write(workbook, wopts)
  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' })
  // string 轉buffer
  function s2ab (s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
    return buf
  }
  return blob
}
// -- public --
export const rows2blob = (names, fieldnames, rows, sheetName = 'jsexcel') => {
  const sheet = rows2sheet(names, fieldnames, rows)
  const blob = sheet2blob(sheet, sheetName)
  return blob
}
export const openDownload = (url, saveName) => {
  // 當傳入的是blob資料 則產生blob url
  if (typeof url === 'object' && url instanceof Blob) url = URL.createObjectURL(url)
  // 建立連結 link
  const aLink = document.createElement('a')
  aLink.href = url
  aLink.download = saveName || ''
  let event
  if (window.MouseEvent) {
    event = new MouseEvent('click')
  } else {
    event = document.createEvent('MouseEvents')
    event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
  }
  aLink.dispatchEvent(event)
}
export const exportExcel = ({ gridFields, names, fieldnames, items, title, fileName = 'output' }) => {
  // console.log('gridFields==')
  // console.log(gridFields)
  if (gridFields !== undefined) {
    // 取得顯示的標頭
    names = gridFields.map(item => {
      return item.name
    })
    // 用來檢查 刪除不顯示的資訊
    fieldnames = gridFields.map(item => {
      return item.fieldname
    })
  }
  // 取得要顯示的資料
  items = items.map(item => {
    for (const prop in item) {
      if (fieldnames.indexOf(prop) === -1) delete item[prop]
    }
    return item
  })
  const blob = rows2blob(names, fieldnames, items, title)
  openDownload(blob, `${fileName}.xlsx`)
}
// export default { rows2blob, openDownload }
